@if (navigating()) {
  <div
    [@fadeIn]
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
  >
    <ss-spinner></ss-spinner>
  </div>
}
